import apiFetch from '../apiFetch'

export default function (token, processingAgencyOrganizedUnitConfig, processAgencyCommunicationServiceId) {
  return apiFetch({ endPoint: `ProcessingAgencyOrganizedUnitConfigs/${processAgencyCommunicationServiceId}`, method: 'POST', body: processingAgencyOrganizedUnitConfig, token: token })
}
